import { SEVERITY_CONFIG } from "admin/types/constants/diagnostics";
import type { DiagnosticSeverity } from "admin/types/interfaces/diagnostics";
import { cn } from "~/lib/utils";

/**
 * Shape of the severity badge, exported for the one state that is not a backend
 * severity: the in-session "Not scored" pill, which carries a muted tint.
 */
export const SEVERITY_PILL_CLASS =
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold";

/** The severity badge shared by the triage drawer, the peek card, and the turn rail. */
export const SeverityPill = ({ severity }: { severity: DiagnosticSeverity }) => {
  const config = SEVERITY_CONFIG[severity];
  return <span className={cn(SEVERITY_PILL_CLASS, config.badgeClass)}>{config.label}</span>;
};
